import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { DbTableDefinition } from 'src/app/_services/persistence/db-persistence/db-table-definition';

@Injectable({
  providedIn: 'root',
})
export class ProjectContactDirectoryDbTableDefinition extends DbTableDefinition {
  tableName = 'projectContactDirectory';
  tableStructure = `(id BIGINT(20) PRIMARY KEY null,
     sourcetype INTEGER,
     label TEXT NOT NULL,
     branchid BIGINT(20),
     personid BIGINT(20),
     functiongroupid BIGINT(20),
     servicejobid BIGINT(20),
     sortorder INTEGER,
     notes TEXT,
     createdtstamp BIGINT(20),
     updatedtstamp BIGINT(20),
     databag LONGTEXT
    );`;

  constructor() {
    super();
    this.updateStatements.set(35, [
      `CREATE TABLE IF NOT EXISTS ${this.tableName}${this.tableStructure}`,
    ]);

    // personlabel/personphone/personemail were added after version 35 already
    // shipped/ran on devices - CREATE TABLE IF NOT EXISTS won't retroactively
    // add columns to an existing table, so this needs a real ALTER TABLE migration.
    if (Capacitor.getPlatform() === 'web') {
      this.alterStatements.push({ table: this.tableName, col: 'personlabel', type: 'TEXT' });
      this.alterStatements.push({ table: this.tableName, col: 'personphone', type: 'TEXT' });
      this.alterStatements.push({ table: this.tableName, col: 'personemail', type: 'TEXT' });
      this.alterStatements.push({ table: this.tableName, col: 'employeeid', type: 'BIGINT(20)' });
      // Order of the entry's function group, see ProjectContactDirectory.functiongroupsortorder
      this.alterStatements.push({ table: this.tableName, col: 'functiongroupsortorder', type: 'INTEGER' });
    } else {
      this.updateStatements.set(42, [
        `ALTER TABLE ${this.tableName} ADD COLUMN personlabel TEXT;`,
        `ALTER TABLE ${this.tableName} ADD COLUMN personphone TEXT;`,
        `ALTER TABLE ${this.tableName} ADD COLUMN personemail TEXT;`,
      ]);
      this.updateStatements.set(43, [
        `ALTER TABLE ${this.tableName} ADD COLUMN employeeid BIGINT(20);`,
      ]);
      // Order of the entry's function group, see ProjectContactDirectory.functiongroupsortorder
      this.updateStatements.set(60, [
        `ALTER TABLE ${this.tableName} ADD COLUMN functiongroupsortorder INTEGER;`,
      ]);
    }
  }
}
